import React, { useRef, useEffect } from "react";
import dynamic from "next/dynamic";
const RefinementList = dynamic(() =>
  import("react-instantsearch").then((mod) => mod.RefinementList)
);
const RangeSlider = dynamic(
  () => import("components/ExperiencePresentation/RangeSliders/RangeSlider")
);
// import RangeSlider from "../RangeSliders/RangeSlider";

import useOutsideClick from "../../../lib/hooks/useOutsideClick";
import useWindowSize from "/lib/hooks/useWindowSize";
import { useInView } from "react-cool-inview";

import styles from "./ExperienceSidebar.module.scss";

const ExperienceSidebar = ({
  closeFilterMenu,
  filterButtonRef,
  currency,
  isFilterOpen,
}) => {
  const sidebarRef = useRef(null);

  const outsideClickRef = useOutsideClick(closeFilterMenu, [
    sidebarRef,
    filterButtonRef,
  ]);

  const windowSize = useWindowSize();

  // const { observe, inView } = useInView({ unobserveOnEnter: true });
  const countryRefinementList = useRef(null);

  useEffect(() => {
    function addLabelToRefinementListInput() {
      if (document.querySelector(".refinement-list-searchable__label")) {
        return;
      }

      const refinementListInput = document.querySelector(
        ".refinement-list-searchable .ais-SearchBox-input"
      );

      function addAccesibilityAttributes() {
        // add name attribute to refinementListInput
        refinementListInput.setAttribute(
          "name",
          "country-refinement-list-searchbox"
        );
        refinementListInput.setAttribute("aria-label", "search-countries");

        // Create dom label element
        const inputLabel = document.createElement("label");
        inputLabel.setAttribute("for", "country-refinement-list-searchbox");
        inputLabel.innerText = "Filter countries by name";
        inputLabel.style = "visibility: hidden; width: 0; height: 0;";
        inputLabel.classList.add("refinement-list-searchable__label");

        refinementListInput.insertAdjacentElement("beforebegin", inputLabel);
      }

      if (refinementListInput) {
        addAccesibilityAttributes();
      }

      if (!refinementListInput) {
        return;
      }

      // console.log(refinementListInput);
    }

    if (
      document.readyState === "complete" ||
      document.readyState === "loaded"
    ) {
      addLabelToRefinementListInput();
    } else {
      window.addEventListener("load", addLabelToRefinementListInput);
    }
  }, [countryRefinementList.current]);

  return (
    <>
      <aside
        className={`${styles.sidebar} ${
          isFilterOpen ? "filterOpen" : "filterClosed"
        }`}
        ref={sidebarRef}
      >
        <div ref={outsideClickRef} className={`${styles.sidebarContent}`}>
          {windowSize.width < 768 && (
            <h1 className={`${styles.sidebarHeader}`}>Advanced Search</h1>
          )}
          <div className={`${styles.refinements}`}>
            <div className={`${styles.refinementListWrapper}`}>
              <p className={`${styles.filterHeading}`}>Region</p>

              <RefinementList
                attribute="location.country.region.regionName"
                className={`${styles.refinementList}`}
              />
            </div>
            <div className={`${styles.refinementListWrapper}`}>
              <p className={`${styles.filterHeading}`}>Category</p>

              <RefinementList
                attribute="experience_categories.category_name"
                className={`${styles.refinementList}`}
              />
            </div>
            <div
              className={`${styles.refinementListWrapper}`}
              ref={countryRefinementList}
            >
              <p className={`${styles.filterHeading}`}>Country</p>

              <RefinementList
                className={`${styles.refinementList} refinement-list-searchable`}
                attribute="location.country.countryName"
                showMore={false}
                showMoreLimit={300}
                limit={30}
                searchable
                placeholder="Find a country"
                autoCapitalize="none"
              />
            </div>

            <div className={`${styles.refinementListWrapper}`}>
              <p className={`${styles.filterHeading}`}>Minimum Duration</p>

              <RangeSlider
                attribute="metadata.minimum_duration"
                unit="week"
                roundMeanTo={2}
                currency={currency}
              />
            </div>
            <div className={`${styles.refinementListWrapper}`}>
              <p className={`${styles.filterHeading}`}>
                Price/Week ({currency.code.toUpperCase()})
              </p>

              <RangeSlider
                attribute={`metadata.currencies.${currency.code.toLowerCase()}`}
                unit="currency"
                roundMeanTo={10}
                currency={currency}
              />
            </div>
          </div>
        </div>
      </aside>

      <div
        className={`${styles.filterModal} ${
          isFilterOpen ? "fadeInAnimation" : "fadeOutAnimation"
        }`}
      />
    </>
  );
};

export default ExperienceSidebar;
